import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  const currentYear = new Date()?.getFullYear();

  const footerLinks = {
    product: [
      { label: 'Stories Library', href: '/stories-library' },
      { label: 'Creator Community', href: '/creator-community' },
      { label: 'Regional Hubs', href: '/regional-hubs' },
      { label: 'Premium Plans', href: '#' }
    ],
    company: [
      { label: 'About Us', href: '/about-us' },
      { label: 'Careers', href: '#' },
      { label: 'Press & Media', href: '#' },
      { label: 'Contact Us', href: '#' }
    ],
    support: [
      { label: 'Help Center', href: '#' },
      { label: 'FAQs', href: '#' },
      { label: 'Community Guidelines', href: '#' },
      { label: 'Report Content', href: '#' }
    ],
    legal: [
      { label: 'Privacy Policy', href: '#' },
      { label: 'Terms of Service', href: '#' },
      { label: 'Cookie Policy', href: '#' },
      { label: 'GDPR Compliance', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: 'facebook', href: '#', label: 'Facebook' },
    { icon: 'twitter', href: '#', label: 'Twitter' },
    { icon: 'instagram', href: '#', label: 'Instagram' },
    { icon: 'youtube', href: '#', label: 'YouTube' }
  ];

  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12">
          <div className="col-span-2">
            <Link href="/homepage" className="flex items-center space-x-2 mb-4">
              <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
                <svg viewBox="0 0 40 40" className="w-8 h-8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <circle cx="20" cy="20" r="18" fill="white" opacity="0.2" />
                  <text x="20" y="26" fontSize="16" fontWeight="700" fill="white" textAnchor="middle" fontFamily="Poppins, sans-serif">
                    SN
                  </text>
                </svg>
              </div>
              <span className="text-xl font-heading font-bold text-primary">StoryNest-FM</span>
            </Link>
            <p className="text-text-secondary mb-4 max-w-xs">
              India's largest audio storytelling platform. Discover stories that speak to your soul in your language.
            </p>
            <div className="flex items-center space-x-4">
              {socialLinks?.map((social) => (
                <a
                  key={social?.icon}
                  href={social?.href}
                  className="w-10 h-10 bg-muted rounded-full flex items-center justify-center text-text-secondary hover:bg-primary hover:text-primary-foreground transition-all duration-300"
                  aria-label={social?.label}
                >
                  <Icon name="ShareIcon" size={20} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading font-bold text-text-primary mb-4">Product</h4>
            <ul className="space-y-2">
              {footerLinks?.product?.map((link) => (
                <li key={link?.label}>
                  <Link
                    href={link?.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-text-primary mb-4">Company</h4>
            <ul className="space-y-2">
              {footerLinks?.company?.map((link) => (
                <li key={link?.label}>
                  <Link
                    href={link?.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-text-primary mb-4">Support</h4>
            <ul className="space-y-2">
              {footerLinks?.support?.map((link) => (
                <li key={link?.label}>
                  <Link
                    href={link?.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-bold text-text-primary mb-4">Legal</h4>
            <ul className="space-y-2">
              {footerLinks?.legal?.map((link) => (
                <li key={link?.label}>
                  <Link
                    href={link?.href}
                    className="text-text-secondary hover:text-primary transition-colors duration-200"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-border">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-text-secondary text-sm">
              © {currentYear} StoryNest-FM. All rights reserved.
            </p>
            <div className="flex items-center space-x-6 text-sm text-text-secondary">
              <span className="flex items-center space-x-2">
                <Icon name="GlobeAltIcon" size={16} />
                <span>Made in India</span>
              </span>
              <span className="flex items-center space-x-2">
                <Icon name="HeartIcon" size={16} variant="solid" className="text-error" />
                <span>For Story Lovers</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}